import React, { useContext, useEffect, useState } from "react";
import { ThemeContext } from "../theme";

const APP_STORE_URL =
    "https://apps.apple.com/us/app/icallon/id6446251262";

const PLAY_STORE_URL =
    "https://play.google.com/store/apps/details?id=com.icallon";

const DownloadApp = () => {
    const { colors } = useContext(ThemeContext)!;
    const [device, setDevice] = useState<"ios" | "android" | "other">("other");

    useEffect(() => {
        const userAgent = navigator.userAgent || navigator.vendor;

        if (/iPad|iPhone|iPod/.test(userAgent)) {
            setDevice("ios");
            window.location.href = APP_STORE_URL;
        } else if (/Android/.test(userAgent)) {
            setDevice("android");
            window.location.href = PLAY_STORE_URL;
        }
    }, []);

    return (
        <section className={`${colors.bgColor} flex items-start justify-center px-6 py-6 md:py-16`}>
            <div
                className={`${colors.cardBg} ${colors.borderColor} border rounded-2xl p-10 max-w-lg text-center shadow-lg`}
            >
                <h1 className={`text-3xl font-bold ${colors.textColor} mb-4`}>
                    Get I Call On
                </h1>

                <p className={`${colors.textColor} opacity-70 mb-8`}>
                    Download the app to start playing. We’ll take you to the right store automatically.
                </p>

                {/* Fallback buttons for desktop or blocked redirect */}
                <div className="flex justify-center gap-6">
                    <button
                        onClick={() => window.open(PLAY_STORE_URL, "_blank")}
                        className="transition-transform hover:scale-105"
                    >
                        <img
                            src={process.env.PUBLIC_URL + "/images/google-play-badge.png"}
                            alt="Google Play"
                            className="h-14"
                        />
                    </button>

                    <button
                        onClick={() => window.open(APP_STORE_URL, "_blank")}
                        className="transition-transform hover:scale-105"
                    >
                        <img
                            src={process.env.PUBLIC_URL + "/images/app-store-badge.png"}
                            alt="App Store"
                            className="h-14"
                        />
                    </button>
                </div>

                {device === "other" && (
                    <p className={`${colors.textColor} opacity-60 text-sm mt-6`}>
                        On desktop? Scan the QR code or choose a store above.
                    </p>
                )}
            </div>
        </section>
    );
};

export default DownloadApp;
